import api from './client'

export const getStats = (params = {}, forceRefresh = false, requestConfig = {}) => {
  const queryParams = new URLSearchParams()
  if (params.mois) queryParams.append('mois', params.mois)
  if (params.annee) queryParams.append('annee', params.annee)
  return api
    .get(`/stats?${queryParams}`, {
      params: queryParams,
      useCache: !forceRefresh,
      ...requestConfig,
    })
    .then((res) => res.data)
}

export const getRevision = (requestConfig = {}) =>
  api.get('/revision', { useCache: false, ...requestConfig }).then((res) => res.data?.v ?? null)

export const getGraphiques = (params = {}, forceRefresh = false, requestConfig = {}) => {
  const queryParams = new URLSearchParams()
  if (params.mois) queryParams.append('mois', params.mois)
  if (params.annee) queryParams.append('annee', params.annee)
  if (params.annee_comparatif) queryParams.append('annee_comparatif', params.annee_comparatif)
  return api
    .get(`/graphiques?${queryParams}`, {
      params: queryParams,
      useCache: !forceRefresh,
      ...requestConfig,
    })
    .then((res) => res.data)
}
